import sanitizeHtml from "sanitize-html";

export const allowClassesAndLinks = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["eon-ui-link"]),
  allowedAttributes: {
    "*": ["class", "style"],
    a: ["href", "name", "target", "noopener", "noreferrer"],
    "eon-ui-link": [
      "a11y-aria-label",
      "display-inline",
      "download",
      "hide-icon",
      "href",
      "icon",
      "icon-position",
      "open-modal-id",
      "scheme",
      "size",
      "target",
      "text"
    ]
  }
};
